export const cardOptions = {
  iconStyle: 'solid',
  style: {
    base: {
      fontWeight: 300,
      fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
      fontSize: '18px',
      fontSmoothing: 'antialiased',
      padding: '4px',
      color: '#ffffff',
      iconColor: '#ffffff',
      '::placeholder': {
        color: 'rgba(255, 255, 255, 0.6)',
      },
    },
    invalid: {
      color: '#ff6b6b',
      iconColor: '#ff6b6b',
    }
  }
}

export function getCardOptions(isLightMode: boolean) {
  if (!isLightMode) {
    return cardOptions;
  }
  return {
    iconStyle: 'solid',
    style: {
      base: {
        fontWeight: 300,
        fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
        fontSize: '18px',
        fontSmoothing: 'antialiased',
        padding: '4px',
        color: '#374151',
        iconColor: '#374151',
        '::placeholder': {
          color: 'rgba(0, 0, 0, 0.4)',
        },
      },
      invalid: {
        color: '#DC2626',
        iconColor: '#DC2626',
      }
    }
  };
}
